var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"web-authn-button",on:{"click":_vm.login}},[_c('i',{staticClass:"fas fa-fingerprint"})])
}
var staticRenderFns = []

export { render, staticRenderFns }